import { render, staticRenderFns } from "./hospitalList.vue?vue&type=template&id=eef59208&scoped=true"
import script from "./hospitalList.vue?vue&type=script&lang=js"
export * from "./hospitalList.vue?vue&type=script&lang=js"
import style0 from "./hospitalList.vue?vue&type=style&index=0&id=eef59208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef59208",
  null
  
)

export default component.exports